<footer class="footer mt-5 px-3 py-4 bg-dark">
  <div class="container-fluid">
    <p class="copyright text-muted my-2 px-md-3 text-md-end">
      My Hivve v{{version}} &copy; {{year}}
      <a href="https://hivve.tech" target="_blank">HIVVE GROUP LTD.</a>
    </p>
  </div>
</footer>
